import StatusPage from 'src/status/containers/StatusPage'

export {StatusPage}
